import { IIconBase } from '..'

const documentTextIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/document-text'>
        <g id='document-text'>
          <path
            id='Vector'
            d='M12.25 4.08317V9.9165C12.25 11.6665 11.375 12.8332 9.33333 12.8332H4.66667C2.625 12.8332 1.75 11.6665 1.75 9.9165V4.08317C1.75 2.33317 2.625 1.1665 4.66667 1.1665H9.33333C11.375 1.1665 12.25 2.33317 12.25 4.08317Z'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.45837 2.625V3.79167C8.45837 4.43333 8.98337 4.95833 9.62504 4.95833H10.7917'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M4.66663 7.5835H6.99996'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M4.66663 9.9165H9.33329'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default documentTextIcon
